export default function IconZero({ className }) {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.128 2.823a6.147 6.147 0 0 0-3.531 1.774 6.109 6.109 0 0 0-1.776 3.564c-.088.618-.088 7.06 0 7.678a6.312 6.312 0 0 0 1.17 2.881 7.859 7.859 0 0 0 1.289 1.289 6.265 6.265 0 0 0 7.44 0 7.859 7.859 0 0 0 1.289-1.289 6.312 6.312 0 0 0 1.17-2.881c.088-.618.088-7.06 0-7.678a6.312 6.312 0 0 0-1.17-2.881 7.859 7.859 0 0 0-1.289-1.289c-1.306-.966-3.008-1.399-4.592-1.168m1.377 2.46c.361.05.868.203 1.155.347a3.862 3.862 0 0 1 2.057 2.863c.059.429.059 6.585 0 7.014a4.016 4.016 0 0 1-.486 1.394 4.182 4.182 0 0 1-1.33 1.33 3.745 3.745 0 0 1-4.461-.499 3.712 3.712 0 0 1-1.157-2.227c-.059-.426-.059-6.584 0-7.01a3.737 3.737 0 0 1 1.108-2.183c.854-.82 1.969-1.188 3.114-1.029"
                fillRule="evenodd"
                fill="#000"
            />
        </svg>
    );
}
